// Category names are typed by hand in the admin — some ALL CAPS, some all lower case.
// For customers show them consistently as a sentence ("Počasí a příroda"); mixed-case names stay as typed.
export function displayName(name: string | undefined | null): string {
  const s = (name ?? '').trim();
  if (!s) return '';
  const letters = s.replace(/[^\p{L}]/gu, '');
  if (!letters) return s;
  const allUpper = letters === letters.toLocaleUpperCase('cs') && letters !== letters.toLocaleLowerCase('cs');
  const allLower = letters === letters.toLocaleLowerCase('cs');
  if (!allUpper && !allLower) return s;
  const lower = s.toLocaleLowerCase('cs');
  return lower.charAt(0).toLocaleUpperCase('cs') + lower.slice(1);
}
